/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type RoofInsulationEnum = 1 | 2 | 3 | 4 | 5 | 6;

export const RoofInsulationEnum = {
    NUMBER_1: 1 as RoofInsulationEnum,
    NUMBER_2: 2 as RoofInsulationEnum,
    NUMBER_3: 3 as RoofInsulationEnum,
    NUMBER_4: 4 as RoofInsulationEnum,
    NUMBER_5: 5 as RoofInsulationEnum,
    NUMBER_6: 6 as RoofInsulationEnum
};

